"use client";

import { stegaClean } from "@sanity/client/stega";

import { useHashScroll } from "@/hooks/useHashScroll";

/**
 * Client component that handles hash scroll for modules with moduleId
 * This is a thin wrapper that only applies the anchor ID and ref
 */
export function ModuleAnchor({
  moduleId,
  children,
}: {
  moduleId?: string | null;
  children: React.ReactNode;
}) {
  moduleId = stegaClean(moduleId || "");
  const anchorRef = useHashScroll(moduleId);

  if (!moduleId) {
    return <>{children}</>;
  }

  return <div ref={anchorRef}>{children}</div>;
}
